import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (user && user !== false) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await login(email, pw);
      nav("/admin", { replace: true });
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0B132B] text-white grid place-items-center px-5 relative overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-30" />
      <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-[#3A506B]/30 blur-3xl" />

      <form onSubmit={submit} data-testid={ADMIN.loginForm} className="relative w-full max-w-md rounded-3xl glass-dark p-8 shadow-high">
        <div className="h-11 w-11 rounded-xl bg-white/10 grid place-items-center mb-6">
          <Lock size={18} />
        </div>
        <div className="text-[11px] tracking-widest uppercase text-slate-400">Admin Access</div>
        <h1 className="mt-2 font-display text-3xl">Be Hire Ready CMS</h1>
        <p className="mt-2 text-sm text-slate-400">Only authorised admins can manage site content and enquiries.</p>

        <label className="block mt-6">
          <span className="text-[11px] tracking-widest uppercase text-slate-400">Email</span>
          <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid={ADMIN.loginEmail}
                 className="mt-1.5 w-full h-11 px-4 rounded-xl bg-white/5 ring-1 ring-white/10 focus:ring-white/30 focus:outline-none text-sm" />
        </label>
        <label className="block mt-4">
          <span className="text-[11px] tracking-widest uppercase text-slate-400">Password</span>
          <input required type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid={ADMIN.loginPassword}
                 className="mt-1.5 w-full h-11 px-4 rounded-xl bg-white/5 ring-1 ring-white/10 focus:ring-white/30 focus:outline-none text-sm" />
        </label>
        <button type="submit" disabled={busy} data-testid={ADMIN.loginSubmit}
                className="mt-6 w-full h-11 rounded-full bg-white text-[#0B132B] text-sm font-semibold disabled:opacity-60 hover:-translate-y-0.5 transition-transform">
          {busy ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
